// https://proptier.sharepoint.com/:x:/s/B2C/EUCzFUB1m2BOrMM41G-OOqABZeGgOYSw-ussPrIcOZBXpQ?e=eIIkW7&wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1728342872799&web=1

const postMessageToApp = (handlerName: string, data?: any, webAlertText?: string) => {
  if (typeof window === 'undefined') return;

  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers[handlerName]
  ) {
    if (['townRealEST', 'showToast'].includes(handlerName)) {
      window.webkit.messageHandlers[handlerName].postMessage(JSON.stringify(data));
    } else {
      window.webkit.messageHandlers[handlerName].postMessage(data);
    }
  } else if (window.Android) {
    const payload = typeof data === 'object' ? JSON.stringify(data) : data;
    if (typeof window.Android[handlerName] === 'function') {
      if (payload === undefined) window.Android[handlerName]();
      else window.Android[handlerName](payload);
    } else {
      console.error(`Error: Android function ${handlerName} is not defined`);
    }
  } else {
    webAlertText && alert(webAlertText);
  }
};

// 로그인(웹뷰에서 로그인 성공시)
export const appToLogin = (token: string) => {
  postMessageToApp('loginSuccess', token);
};

// 닫기(웹뷰 종료)
export const appToClose = () => {
  postMessageToApp('close', '');
};

/** @description 인터페이스 - 관심 추가  */
// {
//   "key": “KEY_FAVORITE_OFFERING”,
//   "value: "communal" // 공동: communal, 비공동:  non_commual
// }
// {
//   “key” : “KEY_FAVORITE_COMPLEX”,
//   “value: “레미안퍼스티지” // 단지명
// }
// {
//   “key: “KEY_FAVORITE_LIMIT”,
//   “value: “offering”  // offering,, complex 매물, 단지
// }
// {
//  “key” : “KEY_UNFAVORITE”,
//  “value: “offering” // offering, complex 매물,, 단지
// }
export const appToFavorite = (obj: {
  key: 'KEY_FAVORITE_OFFERING' | 'KEY_FAVORITE_COMPLEX' | 'KEY_FAVORITE_LIMIT' | 'KEY_UNFAVORITE';
  value: string;
  id?: string;
}) => {
  let alertText;

  if (obj.key === 'KEY_FAVORITE_OFFERING') {
    alertText = `관심매물이 등록되었습니다.`;
  }
  if (obj.key === 'KEY_FAVORITE_COMPLEX') {
    alertText = `관심단지가 등록되었습니다.`;
  }
  if (obj.key === 'KEY_FAVORITE_LIMIT') {
    const valueText = obj.value === 'offering' ? '매물' : '단지';
    alertText = `관심${valueText} 최대 ${obj.value === 'offering' ? 100 : 30}개까지만 등록 가능합니다.`;
  }
  if (obj.key === 'KEY_UNFAVORITE') {
    const valueText = obj.value === 'offering' ? '매물' : '단지';
    alertText = `관심${valueText}이 해제되었습니다.`;
  }

  postMessageToApp('favorite', obj, alertText);
};

/** @description 인터페이스 - 로그인 필요 */
export const appToNeedLogin = () => {
  postMessageToApp('needLogin', undefined, '로그인이 필요합니다');
};

/** @description 위치찾기 요청 */
export const appToFindLocation = () => {
  postMessageToApp('findLocation');
};

/** @description 법정동 코드 저장 */
export const appToSaveBjdCd = (value: string) => {
  postMessageToApp('setString', { key: 'KEY_BJD_CODE', value });
};

/** @description 토스트 출력 */
export const appToToast = (
  value: string | { message: string; imageName: 'icon_success' | 'icon_info' | 'icon_danger' },
) => {
  postMessageToApp('showToast', value);
};

/** @description 공유 */
export const appToShare = (string: string) => {
  postMessageToApp('shareLink', string);
};

/** @description 최근조회 (매물,단지) */
export const appToRecent = (obj: { key: 'offering' | 'complex'; value: string }) => {
  postMessageToApp('recent', obj);
};

/** @description 포토스와이프 호출 */
// {
//   "lifeZoneCode" : "S_1",
//   "themeCode": "T210",
//   "themeName": "최근 등록된 따끈한 집",
//   "realESTClassCdList": "OP, AP", // [선택]매물유형(OR:원/투룸,AP:아파트,OP:오피스텔,VL:빌라/주택)-콤마로구분
//   "offerTypeList": "S,M", // [선택]거래방식(S:매매,Y:전세,M:월세)-콤마로 구분
//   "scPrice2": 15000
// }
export const appToPhotoSwipe = (obj: {
  lifeZoneCode: string;
  themeCode: string;
  themeName: string;
  realESTClassCdList?: string;
  offerTypeList?: string;
  scPrice2?: string;
}) => {
  postMessageToApp('townRealEST', obj);
};

export const appToHome = () => {
  postMessageToApp('backHome', 0);
};

export const appToLogout = () => {
  postMessageToApp('logout');
};

export type stringTitle = 'isInitMemulList' | 'isPyeong';

export const appToGetString = (title: stringTitle) => {
  postMessageToApp('getString', title);
};

export const appToSetString = (title: stringTitle, boolean: string) => {
  postMessageToApp('setString', {
    key: title,
    value: boolean,
  });
};
